const ADD_SECURITY_DAY = "ADD_SECURITY_DAY";
const APPOINTMENT_UPDATED = "APPOINTMENT_UPDATED";
const APPOINTMENT_RECEPTION_CREATED = "APPOINTMENT_RECEPTION_CREATED";
const APPOINTMENT_EXPEDITION_CREATED = "APPOINTMENT_EXPEDITION_CREATED";
const SET_SELECTED_APPOINTMENT = "SET_SELECTED_APPOINTMENT";
const APPOINTMENT_DELETED = "APPOINTMENT_DELETED";

export {
    ADD_SECURITY_DAY,
    APPOINTMENT_UPDATED,
    APPOINTMENT_RECEPTION_CREATED,
    APPOINTMENT_EXPEDITION_CREATED,
    SET_SELECTED_APPOINTMENT,
    APPOINTMENT_DELETED,
};
